import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export const DetailField = ({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) => (
  <Box>
    <Typography variant="caption" color="text.secondary" display="block">
      {label}
    </Typography>
    <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>
      {children || '-'}
    </Typography>
  </Box>
);

export default DetailField;
